/**
 * Permissões do grupo "Usuários" (tela /dashboard/users). Espelha
 * Domain.Security.Permissions.UserManagementFeatures do NotiifyMe — o
 * backend checa as mesmas chaves, então o gating daqui é conveniência de
 * UX (não mostrar o que voltaria 403), nunca a barreira de segurança.
 */
export const UserManagementFeatures = {
  read: "read:user",
  create: "create:user",
  update: "update:user",
  updateStatus: "update_status:user",
  updateAccess: "update_access:user",
  updatePermission: "update_permission:user",
} as const;
